<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<div class="dispute-container">
  <div class="card">
    <div class="logo">
      <img
        class="logo-img"
        src="assets/images/mini-logo.png"
        alt="Company Logo"
      />
    </div>

    <header class="card-header">
      <h1 class="title">Please share your concern</h1>
      <p class="subtitle">
        Zippmat Invoice Number : <strong>{{ invoiceNum }}</strong>
      </p>
    </header>

    <section class="delivery-info">
      <p class="info-label">
        Items Arrived On :
        <span class="delivery-date">{{ deliveryDate | date: "dd/MM/yyyy" }}</span>
      </p>
    </section>

    <section
      *ngIf="!disputeRaised"
      class="dispute-form-section"
    >
      <form
        [formGroup]="disputeForm"
        class="dispute-form"
      >
        <app-text-input
          label="Your Name"
          [control]="$any(disputeForm.get('name'))"
          placeholder="Enter your name"
        >
          <span error>Name is required</span>
        </app-text-input>

        <app-text-input
          label="Your Designation"
          [control]="$any(disputeForm.get('role'))"
          placeholder="Enter your role"
        >
          <span error>Role is required</span>
        </app-text-input>

        <app-mobile-number-input
          label="Your Mobile Number"
          [control]="$any(disputeForm.get('mobile'))"
          placeholder="Enter your mobile number"
        >
          <span error>Mobile Number is required</span>
        </app-mobile-number-input>

        <app-text-input
          label="PO Number"
          [control]="$any(disputeForm.get('poNum'))"
          placeholder="Enter PO number"
        >
          <span error>Invoice Number is required</span>
        </app-text-input>

        <app-text-area-input
          label="Reason For Dispute"
          rows="3"
          [control]="$any(disputeForm.get('reason'))"
          placeholder="Enter reason"
        >
          <span error>Reason is required</span>
        </app-text-area-input>
      </form>
    </section>

    <section
      *ngIf="disputeRaised"
      class="message"
    >
      {{ message }}
    </section>

    <section
      *ngIf="!disputeRaised"
      class="button-group"
    >
      <button
        class="btn raise-dispute"
        (click)="onRaiseDispute()"
        [disabled]="disputeForm.invalid"
      >
        Raise Dispute
      </button>
    </section>
  </div>
</div>
